import { render, staticRenderFns } from "./ConnectCallback.vue?vue&type=template&id=2237c190&"
import script from "./ConnectCallback.vue?vue&type=script&lang=js&"
export * from "./ConnectCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports